import { useMemo } from 'react';
import { useUser } from '../redux/reducer/user';

/**
 * React hook для вычисления текущего режима аккаунта пользователя.
 *
 * Хук использует данные из `useUser` и на основе свойства `isPremium`
 * возвращает режим аккаунта: `"premium"` или `"standard"`.
 *
 * @example
 * ```js
 * const {mode: accountMode} = useAccountMode();
 *
 * if (accountMode === "premium") {
 *   ...
 * }
 * ```
 *
 * @returns {{ mode: 'standard' | 'premium' }} Объект с режимом аккаунта.
 */
export const PREMIUM = 'premium';
export const STANDARD = 'standard';

export const useAccountMode = () => {
  const { profile } = useUser();
  const { isPremium } = profile ?? {};

  return {
    mode: useMemo(() => (isPremium ? PREMIUM : STANDARD), [isPremium]),
  };
};
